import React from "react";
import { Link } from "react-router-dom";

import { useUrlTabLinkTo } from "../hooks/useUrlTabLinkTo";
import { TabItem as TabItemType } from "../types";
import { styles } from "../styles";

import { TabContent } from "./TabContent";

interface SubTabItemProps {
  subTab: TabItemType;
  parentTab: TabItemType;
  isSubActive: boolean;
  vertical?: boolean;
  handleTabChange?: (index: number) => void;
}

export const SubTabItem = ({
  subTab,
  parentTab,
  isSubActive,
  vertical = false,
  handleTabChange,
}: SubTabItemProps) => {
  const subPathname = parentTab.path ? `${parentTab.path}/${subTab.path ?? ""}` : null;
  const linkTo = useUrlTabLinkTo(subPathname);

  const getSubTabClassName = () => {
    const borderClass = vertical ? styles.tab.border.vertical : styles.tab.border.horizontal;
    const activeClass = isSubActive
      ? `${styles.tab.active.base} ${
          vertical ? styles.tab.active.vertical : styles.tab.active.horizontal
        }`
      : styles.tab.inactive;
    const disabledClass = subTab.disabled
      ? "cursor-not-allowed opacity-50 pointer-events-none"
      : "";

    return `${styles.tab.base} ${borderClass} ${activeClass} ${disabledClass} ${
      subTab.className || ""
    }`;
  };

  return (
    <Link
      to={linkTo ?? "#"}
      onClick={e => {
        if (subTab.disabled) {
          e.preventDefault();
          return;
        }
        if (!subTab.path) {
          handleTabChange?.(subTab.id);
          e.preventDefault();
        }
        subTab.onClick?.(e);
      }}
      className={getSubTabClassName()}
      aria-label={`${subTab.name} tab`}
      aria-disabled={subTab.disabled}
    >
      <TabContent
        solidIcon={subTab.solidIcon}
        outlineIcon={subTab.outlineIcon}
        name={subTab.name}
        isActive={isSubActive}
      />
    </Link>
  );
};
